// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","navLink":"Header_navLink__Sd-O5","hiddenMobile":"Header_hiddenMobile__TUV5-"};